<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { devices_config } from '@devices/index';
	import { PROTOTYPES, TEST_DEVICES } from 'src/constants';

	import { Text } from '@Shelly/shelly-design-system';

	import TransitionWrapper from 'src/components/Utility/TransitionWrapper.svelte';
	import SelectList from 'src/components/SelectList/SelectList.svelte';

	import { isDevServerUser, isT1User } from 'src/helpers/user_server_conditions';

	export let inclusionData;

	let selectItems: { id: string }[] = [];

	let filteredConfig = Object.fromEntries(
		Object.entries(devices_config).filter(
			(v, i, a) => a.findIndex((v2) => v2[1].friendly_name === v[1].friendly_name) === i,
		),
	);

	const anyItem = {
		id: 'any',
		type: 'any',
		name: 'Any',
		image: 'images/device_images/logo_white_S.png',
		ap: 'any',
	};

	let deviceTypes = Object.keys(filteredConfig)
		.filter((type) => !PROTOTYPES.includes(type))
		.filter((type) => {
			return !isDevServerUser(['repo', 'nb']) || !isT1User() ? !TEST_DEVICES.includes(type) : type;
		})
		.map((type) => {
			return {
				id: type,
				name: `Shelly ${devices_config[type].friendly_name}`,
				image: `images/device_images/${type}.png`,
				ap: devices_config[type].name,
			};
		});

	const handleSelectItem = (detail) => {
		selectItems = [
			{
				id: detail.id,
			},
		];
		inclusionData.selected = detail.ap;
	};

	deviceTypes = [anyItem, ...deviceTypes];
	handleSelectItem({ ap: 'any', id: 'any' });
</script>

<Text element="h2" class="mb-s">
	{$format('inclusion_wifi_device_type', {
		default: 'Device type',
	})}
</Text>
<Text class="mb-s" styleType="body-small">
	{$format('inclusion_wifi_device_type', {
		default: 'Select the device you want to include.',
	})}
</Text>
<TransitionWrapper>
	<SelectList
		title={''}
		list={deviceTypes}
		variant={'radio'}
		selectedCardsId={selectItems}
		on:click={(e) => handleSelectItem(e.detail)}
	/>
</TransitionWrapper>
